// Rutas del sitio web
const APP = {
    INDEX: '/',
    NOTFOUND: '*',
    HOME: '/Home',
    ADMINISTRADOR: '/Administrador',
    USUARIO: '/Usuario',
    CAJA: '/CajasTexto',
    TABLE: '/Tablas',
    BOTON: '/Botones',
    OTROS: '/Otros'
}

export default APP;